import React from "react";

export default function EmptyState({ icon: Icon, title, description, action, testId }) {
  return (
    <div
      data-testid={testId}
      className="sm-card px-6 py-12 text-center flex flex-col items-center gap-3"
    >
      {Icon ? (
        <div className="w-14 h-14 rounded-full bg-[#F2EFE8] border border-[#E3DED4] flex items-center justify-center">
          <Icon className="w-6 h-6 text-[#1F6F78]" />
        </div>
      ) : null}
      <h3 className="font-display text-xl text-[#1F2A2E]">{title}</h3>
      {description ? (
        <p className="text-sm text-[#4B5A60] max-w-md leading-6">{description}</p>
      ) : null}
      {action ? <div className="pt-2">{action}</div> : null}
    </div>
  );
}
